export default IconStack3 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-stack-3" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 2l-8 4l8 4l8 -4l-8 -4" />
  <path d="M4 10l8 4l8 -4" />
  <path d="M4 18l8 4l8 -4" />
  <path d="M4 14l8 4l8 -4" />
</svg>`;